/* eslint-disable react-hooks/exhaustive-deps */

import { useCallback, useEffect, useState } from 'react';

import { Button, Checkbox, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import './style.scss';

import NightOwlLogo from 'assets/svgs/NightOwl-Logo-Black.svg';
import ErrorFallback from 'components/error-fallback';
import useLogout from 'middleware/accounts/user/useLogout';
import useFetchTermsOfUse from 'middleware/hcp/termsOfUse/useFetchTermsOfUse';
import usePostTermsOfUse from 'middleware/hcp/termsOfUse/usePostTermsOfUse';
import { getAPIServer } from 'utils/storage';

import TermsOfUseSupport from './not-accept';
import PDFViewer from './pdfView';

const TermsOfUse = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const region = getAPIServer() || '';
  const language = 'en';
  const location = useLocation();
  const termsUseState = location.state;
  const [notAccept, setNotAccept] = useState(false);

  const { logout, isPending } = useLogout();

  const { termsData } = useFetchTermsOfUse(language, region, !!termsUseState);
  const data = termsData || termsUseState;
  const { saveTermsOfUse, saving } = usePostTermsOfUse();
  const accept = Form.useWatch('accept-termsUse', form);

  useEffect(() => {
    if (data?.versionReadByPortalUser === null || data?.versionReadByPortalUser === 'notLatest') {
      localStorage.setItem('terms', 'false');
    }
  }, []);

  const handleLogout = useCallback(() => {
    logout(null);
  }, []);

  const handleDeny = useCallback(() => {
    setNotAccept((pre) => !pre);
  }, []);

  const onCancel = useCallback(() => {
    setNotAccept(false);
  }, []);

  if (!data) {
    return (
      <ErrorFallback
        actionText="Go back to home page"
        errorText="Page not found"
        actionHandler={() => {
          window.location.pathname = '';
        }}
      />
    );
  }

  const onConfirm = async () => {
    try {
      await saveTermsOfUse({ version_id: data?.versionId, type: 'nightowl-portal' });
      localStorage.setItem('terms', 'true');
      navigate('/', { replace: true });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="terms-container">
      <img id="nightOwl_logo" src={NightOwlLogo} alt="" className="terms-logo" />
      <div className="terms-use-box">
        <div className="terms-use-header">
          <h2 className="terms-title">{t('auth.terms-of-use.title')}</h2>
        </div>
        <PDFViewer file={data?.s3Url} />
        {notAccept && <TermsOfUseSupport closeModal={onCancel} />}
        <Form
          form={form}
          layout="vertical"
          requiredMark={false}
          name="activate"
          initialValues={{ accept: true }}
          onFinish={onConfirm}
          autoComplete="off">
          <Form.Item name="accept-termsUse" valuePropName="checked">
            <Checkbox className="accept-terms">{t('auth.terms-of-use.accept-terms')}</Checkbox>
          </Form.Item>
          <div className="buttons-container">
            <Button
              id="terms_confirm"
              disabled={!accept}
              loading={saving}
              type="primary"
              htmlType="submit">
              {t('auth.terms-of-use.accept')}
            </Button>
            <Button
              id="terms_not_confirm"
              className="button-default"
              onClick={handleDeny}
              type="default"
              htmlType="button">
              {t('auth.terms-of-use.not-accept')}
            </Button>
            <Button
              id="terms_sign_out"
              className="button-default"
              loading={isPending}
              onClick={handleLogout}
              type="default"
              htmlType="button">
              {t('header.sign-out')}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default TermsOfUse;
